export default {
  ERRORS: {
    ACCESS: {
      TITLE: '¡Acción denegada!',
      SUBTITLE: 'Consulta con el administrador de tu empresa para ampliar tus permisos y subir tu nivel de acceso.',
      RETURN: 'Ir al panel de control',
    },
    ERROR: {
      TITLE: 'Se produjo un error',
      SUBTITLE: 'El recurso solicitado no está disponible.',
      RETURN: 'Ir al panel de control',
    },
    NOT_FOUND: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      404: '404',
      TITLE: 'Not Found',
      SUBTITLE: 'El recurso solicitado no está disponible.',
      FAQ: {
        TITLE: 'Preguntas frecuentes',
        SUBTITLE: 'Ultricies mi quis hendrerit dolor.',
      },
      SOLUTION_CENTER: {
        TITLE: 'Centro de Soluciones',
        SUBTITLE: 'Phasellus faucibus scelerisque eleifend.',
      },
      PERMISSION_MANAGER: {
        TITLE: 'Administrador de permisos',
        SUBTITLE: 'Accumsan en nisl nisi scelerisque',
      },
    },
    OFFER_NOT_FOUND: {
      TITLE: 'Esta oferta ya no está disponible',
      CLOSED_MESSAGE: 'La empresa ha cerrado esta vacante.',
      DISCOVER_MESSAGE: 'Descubre nuevas oportunidades en wokap.',
      DOWNLOAD_APP: 'Descarga la app',
      VIEW_OTHER_OFFERS: 'Ver otras ofertas',
    },
  },
} as const;
